import { useMemo } from "react";
import usePluggableSecurityEventActions from "security-app/components/SecurityEvents/Alerts/usePluggableSecurityEventActions";
const useSecurityEventBulkAction = (events) => {
  const { actions: pluggableActions, actionModals: pluggableActionModals } = usePluggableSecurityEventActions(
    events,
    true
  );
  const actions = useMemo(() => [pluggableActions].filter(Boolean), [pluggableActions]);
  return { actions, pluggableActionModals };
};
export default useSecurityEventBulkAction;
